import { Modal } from 'antd';
import CollectionListModal from 'pages/Collection/CollectionListModal';
import React from 'react';
import { CollectionSelectedType } from './CollectionSelect';

export type CollectionSearchModalProps =  {
  tpid?:number
  visible: boolean;
  onCancel: () => void;
  setCollection?: (
    Collection: CollectionSelectedType
  ) => void;
};

const CollectionSearchModal = ({
  onCancel,
  visible,
  setCollection,
  tpid
}: CollectionSearchModalProps) => {
  return (
    <Modal open={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <CollectionListModal
        onSelect={setCollection}
        tpid={tpid}
      />
    </Modal>
  );
};

export default CollectionSearchModal;
